import { useRef, useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { useOutletContext } from 'react-router-dom';
import BadgeSquare from 'components/badge/badgeSquare';
import useModal from 'components/modal/useModal';
import useSlideOver from 'components/SlideOver/useSlideOver';
import UseContext from 'hooks/useContext';
import { Dots } from 'assets/icons';

const TbodypayslipAdmin = ({ champsBody }) => {
  return (
    <>
      {champsBody?.map((item, index) => (
        <PayslipRow key={`${item.id_temp_worker_bestt}-${index}`} item={item} />
      ))}
    </>
  );
};

const PayslipRow = ({ item }) => {
  const { toggle } = useModal();
  const { toggleSlideOver } = useSlideOver();
  const {
    setObjID,
    setAdminType,
    setAdminTempWorkerId,
    setAdminUserId,
    setAdminFileName,
    setModalData,
    setTarget,
  } = UseContext();
  const { selectedIds, setSelectedIds, year, month } = useOutletContext();

  const isSelected = selectedIds.includes(item.id_temp_worker_bestt);
  const isImported = item.status === 'imported';

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
  const dropDownRef = useRef(null);
  const dotsRef = useRef(null);

  const updateDropdownPos = useCallback(() => {
    if (dotsRef.current) {
      const rect = dotsRef.current.getBoundingClientRect();
      const menuHeight = isImported ? 120 : 40;
      const fitsBelow = rect.bottom + 4 + menuHeight < window.innerHeight;
      setDropdownPos({
        top: fitsBelow ? rect.bottom + 4 : rect.top - menuHeight - 4,
        left: rect.right - 192,
      });
    }
  }, [isImported]);

  useEffect(() => {
    const handler = (e) => {
      if (
        dropDownRef.current && !dropDownRef.current.contains(e.target) &&
        dotsRef.current && !dotsRef.current.contains(e.target)
      )
        setDropdownOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleCheckbox = () => {
    setSelectedIds((prev) =>
      isSelected
        ? prev.filter((id) => id !== item.id_temp_worker_bestt)
        : [...prev, item.id_temp_worker_bestt]
    );
  };

  const handleRowClick = () => {
    if (!item.id_user) return;
    setModalData({ payslipYear: item.year, payslipMonth: item.month });
    setTarget('payslip');
    setObjID(item.id_user);
    toggleSlideOver('get_temp_worker');
  };

  const handleViewPayslip = () => {
    setDropdownOpen(false);
    const fileName = `payslip_${item.id_temp_worker_bestt}_${item.year}_${item.month}`;
    setAdminType('payslip');
    setAdminTempWorkerId('');
    setAdminUserId(item.id_user);
    setAdminFileName(fileName);
    toggle('ad_file_view');
  };

  const handleImport = () => {
    setDropdownOpen(false);
    setModalData({ payslips: [item], year, month });
    toggle('payslip_import_unit');
  };

  const handleDelete = () => {
    setDropdownOpen(false);
    setModalData({ payslips: [item], year, month });
    toggle('payslip_delete');
  };

  return (
    <tr className="border-b border-gray-100 hover:bg-gray-50">
      <td className="px-2 py-3">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={handleCheckbox}
          className="cursor-pointer"
        />
      </td>
      <td
        className="px-2 py-3 cursor-pointer"
        onClick={handleRowClick}
      >
        {item.id_temp_worker_bestt}
      </td>
      <td
        className="px-2 py-3 cursor-pointer"
        onClick={handleRowClick}
      >
        {item.lastname} {item.firstname}
      </td>
      <td
        className="px-2 py-3 cursor-pointer"
        onClick={handleRowClick}
      >
        {item.year}/{item.month}
      </td>
      <td
        className="px-2 py-3 cursor-pointer"
        onClick={handleRowClick}
      >
        {item.amount ? `${Number(item.amount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €` : '-'}
      </td>
      <td className="px-2 py-3">
        <BadgeSquare type={isImported ? 12 : 13} />
      </td>
      <td className="px-2 py-3">
        <div
          className="cursor-pointer w-9 h-9 flex items-center justify-center rounded hover:bg-gray-100"
          ref={dotsRef}
          onClick={() => {
            updateDropdownPos();
            setDropdownOpen(!dropdownOpen);
          }}
        >
          <Dots w={14} h={4} color="#374151" />
        </div>
        {dropdownOpen && createPortal(
          <div
            ref={dropDownRef}
            className="fixed border-2 border-[#F3F4F6] rounded-lg shadow-lg w-48 bg-gray-50 z-[9999]"
            style={{ top: dropdownPos.top, left: dropdownPos.left }}
          >
            {!isImported ? (
              <div
                className="flex flex-row gap-2 items-center h-9 p-2 ft-sm cursor-pointer hover:bg-gray-100"
                onClick={handleImport}
              >
                Importer
              </div>
            ) : (
              <>
                <div
                  className="flex flex-row gap-2 items-center h-9 p-2 ft-sm cursor-pointer hover:bg-gray-100 text-gray-900"
                  onClick={handleViewPayslip}
                >
                  Consulter la fiche
                </div>
                <div
                  className="flex flex-row gap-2 items-center h-9 p-2 ft-sm cursor-pointer hover:bg-gray-100"
                  onClick={handleImport}
                >
                  Importer à nouveau
                </div>
                <div
                  className="flex flex-row gap-2 items-center h-9 p-2 ft-sm cursor-pointer hover:bg-gray-100 text-red-500"
                  onClick={handleDelete}
                >
                  Supprimer
                </div>
              </>
            )}
          </div>,
          document.body
        )}
      </td>
    </tr>
  );
};

export default TbodypayslipAdmin;
